export const ServiceComIcon = ({ fill = '#808CB2' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
        <path
            d="M11.8174 9.94881H19.8416"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M19.8418 14.0059H12.8389"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M19.8415 18.0628H13.8599"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <rect
            x="3.50146"
            y="3.50146"
            width="21.0087"
            height="21.0087"
            rx="7"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.53358 9.65703C8.37258 9.65767 8.24253 9.78859 8.24296 9.94959C8.24339 10.1106 8.37414 10.2408 8.53513 10.2406C8.69613 10.2404 8.82653 10.1098 8.82654 9.94881C8.82685 9.87113 8.79605 9.79655 8.74101 9.74173C8.68596 9.68691 8.61126 9.6564 8.53358 9.65703"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.55458 13.7142C9.39358 13.7148 9.26353 13.8457 9.26396 14.0067C9.26438 14.1677 9.39513 14.2979 9.55613 14.2977C9.71713 14.2975 9.84753 14.1669 9.84753 14.0059C9.84785 13.9283 9.81704 13.8537 9.762 13.7989C9.70696 13.744 9.63226 13.7135 9.55458 13.7142"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.5761 17.771C10.4151 17.7717 10.285 17.9026 10.2854 18.0636C10.2859 18.2246 10.4166 18.3548 10.5776 18.3546C10.7386 18.3544 10.869 18.2238 10.869 18.0628C10.8693 17.9851 10.8385 17.9106 10.7835 17.8557C10.7284 17.8009 10.6537 17.7704 10.5761 17.771"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
